import { Parameter } from "../models/Parameter";
import { PaginatedList } from "../helpers/PaginatedList";
import { MessagingHelper } from "../helpers/MessagingHelper";
import { APIService } from "./APIService";
import { AssistanceCheckListDTO } from "../models/AssistanceCheckList/AssistanceCheckListDTO";
import { CreateAssistanceCheckListDTO } from "../models/AssistanceCheckList/CreateAssistanceCheckListDTO";
import { CheckListModelDTO } from "../models/CheckListModel/CheckListModelDTO";
import { EditAssistanceCheckListDTO } from "../models/AssistanceCheckList/EditAssistanceCheckListDTO";
import { EquipmentDTO } from "../models/Equipment/EquipmentDTO";

export class AssistanceCheckListService {
    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number
    ): Promise<MessagingHelper<CheckListModelDTO[]>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckList/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {

            return new MessagingHelper<CheckListModelDTO[]>(
                false,
                "Erro ao obter a associação entre a assistência e a checklist",
                []
            );
        }
    }

    async Create(
        createAssistanceCheckList: CreateAssistanceCheckListDTO
    ): Promise<MessagingHelper<number>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckList/Create`,
                {
                    ...createAssistanceCheckList,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.data;
        } catch (error) {
            return new MessagingHelper<number>(
                false,
                "Erro ao ligar ao servidor para obter a associação entre a assistência e a checklist",
                0
            );
        }
    }

    async GetById(id: number): Promise<MessagingHelper<AssistanceCheckListDTO | null>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/AssistanceCheckList/${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a associação entre a assistência e a checklist",
                null
            );
        }
    }

    async Edit(
        assistanceChecklistUpdate: EditAssistanceCheckListDTO
    ): Promise<MessagingHelper<null>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckList/Edit`,
                { ...assistanceChecklistUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para atualizar a associação da checklist",
                null
            );
        }
    }

    async GetEquipmentsByCheckListModel(
        checkListModelId: number,
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number
    ): Promise<PaginatedList<EquipmentDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckList/GetEquipmentsByCheckListModel?checkListModelId=${checkListModelId}`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<EquipmentDTO>(
                false,
                "Erro ao obter a informação sobre os Equipamentos da Checklist",
                "",
                [],
                0
            );
        }
    }


}


